module.exports = __webpack_public_path__ + "static/hunger-aedad3dc81262bc86e06012aa3e3bc35.png";